((w, d, fdl, h, $) => {
	const isIos = (['iPad Simulator',
		'iPhone Simulator',
		'iPod Simulator',
		'iPad',
		'iPhone',
		'iPod'
	].includes(navigator) || (navigator.userAgent.includes('Mac') && 'ontouchend' in document)); // iPad on iOS 13 detection

	const isSafari = (navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && navigator.userAgent.indexOf('CriOS') === -1 && navigator.userAgent.indexOf('FxiOS') === -1);

	// default cookie compliance script
	function cookieCompliance() {
		if (!window.biscuit.checkBiscuit('cookieCompliance') && document.querySelector('.biscuit-banner')) {
			document.querySelector('.biscuit-banner').classList.add('biscuit-banner--show');
		}

		if (document.querySelector('.biscuit-banner__button')) {
			document.querySelector('.biscuit-banner__button').addEventListener('click', (e) => {
				e.preventDefault();

				window.biscuit.writeBiscuit('cookieCompliance', true, { 'expires': 14, 'path': '/' });
				e.target.closest('.biscuit-banner').classList.add('biscuit-banner--hide');
			});
		}

		if (document.querySelector('.biscuit-banner__button--close')) {
			document.querySelector('.biscuit-banner__button--close').addEventListener('click', (e) => {
				e.preventDefault();

				if (window.biscuit.checkBiscuit('cookieCompliance')) {
					window.biscuit.eatBiscuit('cookieCompliance');
				}
				e.target.closest('.biscuit-banner').classList.add('biscuit-banner--hide');
			});
		}
	}

	// default navicon
	function navicon() {
		document.querySelector('.site-header__navicon').addEventListener('click', (e) => {
			e.preventDefault();
			document.querySelector('body').classList.toggle('nav--open');
		});
	}

	document.addEventListener('DOMContentLoaded', () => {
		if (navigator.userAgent.indexOf('Win') !== -1) {
			document.querySelector('body').classList.add('windows');
		}

		window._farlo.browser.init();
		window._farlo.storage.checker();

		if (isSafari) {
			document.querySelector('body').classList.add('safari');
		}

		if (isIos) {
			document.querySelector('body').classList.add('ios');
		}

		if (document.querySelector('.site-header__navicon')) {
			navicon();
		}

		if (document.querySelector('.biscuit-banner')) {
			cookieCompliance();
		}
	});

	// Tolerance (px) is the size a viewport can chance
	// before updating css variables this prevents jerky
	// resizing when browser chrome disappears on mobile
	const tolerance = 60;

	let vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty('--vh', `${ vh }px`);
	let lastHeight = window.innerHeight;

	let vw = window.innerWidth * 0.01;
	document.documentElement.style.setProperty('--vw', `${ vw }px`);
	let lastWidth = window.innerWidth;

	let header;

	if (document.querySelector('#site-header')) {
		header = document.querySelector('#site-header').getBoundingClientRect().height;
		document.documentElement.style.setProperty('--navbar-offset', header);
		if (document.querySelector('#promo-bar')) {
			header += document.querySelector('#promo-bar').getBoundingClientRect().height;
		}
		document.documentElement.style.setProperty('--nav-offset', header);
	}

	const resizeVars = () => {
		if (Math.abs(lastHeight - window.innerHeight) > tolerance) {
			vh = window.innerHeight * 0.01;
			document.documentElement.style.setProperty('--vh', `${ vh }px`);
			lastHeight = window.innerHeight;
		}

		if (lastWidth != window.innerWidth) {
			vw = window.innerWidth * 0.01;
			document.documentElement.style.setProperty('--vw', `${ vw }px`);
			lastWidth = window.innerWidth;
		}

		if (document.querySelector('#site-header')) {
			header = document.querySelector('#site-header').getBoundingClientRect().height;
			document.documentElement.style.setProperty('--navbar-offset', header);

			if (document.querySelector('#promo-bar')) {
				header += document.querySelector('#promo-bar').getBoundingClientRect().height;
			}
			document.documentElement.style.setProperty('--nav-offset', header);
		}
	};
	window.addEventListener('resize', () => {
		resizeVars();
	});
	setTimeout(function() {
		resizeVars();
	}, 100);

	if (document.querySelector('.masthead-section-expandable')) {
		document.querySelectorAll('.masthead-section-expandable').forEach((_sel) => {
			_sel.addEventListener('click', () => {
				_sel.classList.toggle('masthead-section--active');
			});
		});
	}

	window.addEventListener('load', () => {
		document.querySelector('body').classList.add('loaded');

		const promo_bar = document.querySelector('.promo-bar__list');
		if (promo_bar) {
			const promo_slider = new Flickity(promo_bar, {
				cellAlign: 'left',
				wrapAround: true,
				draggable: true,
				pageDots: false,
				prevNextButtons: false,
				autoPlay: 1500
			});
		}
	});

	if ($('.display-variant-icons').length > 0) {
		$(document).on('change', '.variation-radios input', function() {
			$('.variation-radios input:checked').each(function(index, element) {
			  const $el = $(element);
			  const thisName = $el.attr('name');
			  const thisVal = $el.attr('value');
			  $('select[name="' + thisName + '"]').val(thisVal).trigger('change');
			  if (thisVal !== "") {
				$(this).parents(".variations__item").next().addClass("variations__item-active");
			  }
			});
		  });
		  $(document).on('woocommerce_update_variation_values', function() {
			$('.variation-radios input').each(function(index, element) {
			  const $el = $(element);
			  const thisName = $el.attr('name');
			  const thisVal = $el.attr('value');

			  $el.removeAttr('disabled');

			  if (!$('select[name="' + thisName + '"] option[value="' + thisVal + '"]').hasClass('enabled')) {
					if (thisName === 'attribute_pa_pack-size') {
						$el.prop('disabled', true);
					}
			  }
			});
		  });
		  $('.reset_variations').on('click', () => {
			$('.variation-radios input').each(function(index, element) {
				$(element).prop('checked', false);
			});
		  });
		  $("input[name='attribute_pa_pack-type']").on('click', (el) => {
			$('.variation-radios input').each(function(index, element) {
				$(element).prop('checked', false);
			});
			$('#pa_pack-size').val('');
			el.target.checked = true;
		  });
	}

	let updaterRuns = 0;

	const titleUpdater = setInterval(() => {
		updaterRuns ++;
		$('.wc-blocks-components-form-token-field-wrapper').each(function() {
			if (!$(this).hasClass('is-loading')) {
				$(this).find('.components-form-token-field__input').attr('placeholder', $(this).parent().prev('h5').text());
				clearInterval(titleUpdater);
			}
		});
		if (updaterRuns > 10) {
			clearInterval(titleUpdater);
		}
	}, 500);

	if (document.querySelector('.bg-load')) {
		window.addEventListener('load', () => {
			document.querySelectorAll('.bg-load').forEach((_el) => {
				if (_el.dataset.bg) {
					_el.style.backgroundImage = 'url(' + _el.dataset.bg + ')';
				}
 				});
		});
	}

	if (document.querySelector(".add_gift_card_form")) {
		var form = document.querySelector("#wc_gc_cart_redeem_form");

		document.querySelector(".add_gift_card_form h4").addEventListener("click", () => {
			document.querySelector(".add_gift_card_form").classList.toggle("gift-card-display");
			form.style.height= form.scrollHeight + 'px';
			setTimeout(() => {
				form.style.height = "auto";
			},500);
		})
	}

	if (document.querySelector(".custom-selection")) {
		const customisedCollection = document.querySelector(".custom-selection");
		const uid = _farlo.helpers.urls.getQueryValue("uid");
		customisedCollection.querySelectorAll("a").forEach((_a) => {
			_a.href += "?uid=" + uid;
		});
	}

	const cartTrigger = document.querySelector("#mobile-cart-button-trigger");
	if (cartTrigger) {
		document.querySelector("#close-variant-overlay").addEventListener("click", () => {
			document.querySelector("body").classList.toggle("variations-toggled");
		})		
		cartTrigger.querySelector("button").addEventListener("click", () => {
			document.querySelector("body").classList.toggle("variations-toggled");
		})
	}

	const couponTrigger = document.querySelector(".woocommerce-form-coupon-toggle-open");
	if (couponTrigger) {	
		document.querySelectorAll(".woocommerce-form-coupon-toggle-open, .woocommerce-form-coupon-toggle-close").forEach((_tgl) => {
			_tgl.addEventListener("click",() => {	
				document.querySelector(".woocommerce-form-coupon-toggle-container").classList.toggle("coupon-container-toggled");
			});
		});
	}



	// function mailchimpForm() {
    //     $(d).submit($(this), function(e) {
    //         const $form = $(e.target).closest('form');
    //         let $message = $(e.target).closest('form').siblings('.form__message');

    //         e.preventDefault();

    //         $message.html("Adding your email address...");
    //         $.ajax({
    //             url: '/app/themes/Farlo/inc/helpers/Mailchimp/index.php',
    //             type: 'POST',
    //             data: $form.serialize() + '&ajax=true',
    //             success: function(msg) {
    //                 let message = $.parseJSON(msg);
    //                 let result = '';

    //                 if (message) {
    //                     if (message.status === 400 && message.title === 'Member Exists') {
    //                         result = '<div class="form__message-text"><p>Thank you for your interest in Crafty Brewing mailing list. It looks as though you\'re already subscribed. Hold tight for further information.</p></div>';
    //                     } else if (message.status === 'pending') { // success
    //                         result = '<div class="form__message-text"><p>Thank you for signing up to Crafty Brewing mailing list. Please check your emails to confirm the subscription and we will be in touch shortly with more news!</p></div>';

    //                         if (typeof fdl !== 'undefined') {
    //                             fdl.push({
    //                                 "event" : "GAEvent",
    //                                 "eventCategory" : "Interaction",
    //                                 "eventAction" :  "Signup",
    //                                 "eventLabel" : "Success"
    //                             });
    //                         }
    //                     } else {
    //                         result = '<p>An error has occurred, please try again later.</p>';
    //                     }
                        
    //                     $message.addClass('form__message--show').html(result);
    //                     $form.addClass('form--hidden');
    //                 }
    //             }
    //         });
    //         return false;
    //     });
    // }
	$(document).ready(function() {
		$('.sign-up').submit(function(e) {

			let _message = $(this).siblings('.form__message');
			let _this = $(this);
            e.preventDefault();

            _message.html("Adding your email address...");
            $.ajax({
                url: '/app/themes/Farlo/inc/helpers/Mailchimp/index.php',
                type: 'POST',
                data: $(this).serialize() + '&ajax=true',
                success: function(msg) {
                    let message = $.parseJSON(msg);
                    let result = '';

                    if (message) {
                        if (message.status === 400 && message.title === 'Member Exists') {
                            result = '<div class="form__message-text"><p>Thank you for your interest in Crafty Brewing mailing list. It looks as though you\'re already subscribed. Hold tight for further information.</p></div>';
                        } else if (message.status === 'pending') { // success
                            result = '<div class="form__message-text"><p>Thank you for signing up to Crafty Brewing mailing list. Please check your emails to confirm the subscription and we will be in touch shortly with more news!</p></div>';

                            if (typeof fdl !== 'undefined') {
                                fdl.push({
                                    "event" : "GAEvent",
                                    "eventCategory" : "Interaction",
                                    "eventAction" :  "Signup",
                                    "eventLabel" : "Success"
                                });
                            }
                        } else {
                            result = '<p>An error has occurred, please try again later.</p>';
                        }
                        
                        _message.addClass('form__message--show').html(result);
                        _this.addClass('form--hidden');
                    }
                }
            });

		});

	});


	document.querySelector("#search-button").addEventListener("click", () => {
		document.querySelector("body").classList.add("search-enabled");
		document.querySelector("[name='s']").focus();
	});
	document.querySelector("[name='s']").addEventListener("blur",() => {
		document.querySelector("body").classList.remove("search-enabled");
	});

	if (typeof navigator !== 'undefined') {
		navigator.serviceWorker.getRegistrations().then(function(registrations) {
			for (const registration of registrations) {
				registration.unregister();
			}
		});
	}


})(window, document, typeof dataLayer !== 'undefined' ? dataLayer : [], history, jQuery);
